import { useSelector } from 'react-redux';

export const useGetIdLanguage = () => {
  const languageKey = useSelector((store) => store.languageTraslate.language) || {
    id: 3,
    name: 'Ingles',
    description: 'En',
    value: 3
  };

  return languageKey.value;
};

export const useGetLanguage = () => {
  const language = useSelector((store) => store.languageTraslate);
  return language;
};
